import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en';
import { ru } from './ru';

export const ADMIN_NS = 'admin';
export const ADMIN_LANGUAGE_KEY = 'routellers_admin_language';
export const ADMIN_LANGUAGES = ['ru', 'en'] as const;
export type AdminLanguage = (typeof ADMIN_LANGUAGES)[number];

const readStoredLanguage = (): AdminLanguage => {
    try {
        const raw = localStorage.getItem(ADMIN_LANGUAGE_KEY)?.slice(0, 2).toLowerCase();

        if (raw === 'en' || raw === 'ru') return raw;
    } catch {
        // SSR / restricted storage
    }

    return 'ru';
};

const applyDocumentLang = (lng: string) => {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng;
    }
};

void i18n.use(initReactI18next).init({
    lng: readStoredLanguage(),
    fallbackLng: 'en',
    compatibilityJSON: 'v3',
    ns: [ADMIN_NS],
    defaultNS: ADMIN_NS,
    resources: {
        en: { [ADMIN_NS]: en },
        ru: { [ADMIN_NS]: ru },
    },
    supportedLngs: [...ADMIN_LANGUAGES],
    load: 'languageOnly',
    returnNull: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});

applyDocumentLang(i18n.language);

i18n.on('languageChanged', (lng) => {
    applyDocumentLang(lng);
});

export const setAdminLanguage = (lng: string): void => {
    const next: AdminLanguage = lng.slice(0, 2).toLowerCase() === 'en' ? 'en' : 'ru';

    try {
        localStorage.setItem(ADMIN_LANGUAGE_KEY, next);
    } catch {
        // ignore
    }

    if (i18n.language !== next) {
        void i18n.changeLanguage(next);
    }
};

export { enumLabel, enumOptions } from './enum-options';
export default i18n;
